<!-- Base.SearchForm.vue (client-lms) -->
<template>
  <div class="lms_search_input" :class="{ focused: isFocused }">
    <i v-if="!model" class="icon_search"></i>
    <input
      type="search"
      class="lms_search_field"
      :value="model"
      :placeholder="placeholder"
      @input="model = ($event.target as HTMLInputElement).value"
      @keyup.enter="onSearch"
      @focus="isFocused = true"
      @blur="isFocused = false"
    />
    <button v-if="model" type="button" class="lms_search_clear" @click="onClear">
      <i class="mdi mdi-close"></i>
    </button>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";

const model = defineModel<string>({ required: true });

const props = defineProps({
  placeholder: { type: String, default: "검색" },
  onSearch: { type: Function, required: false, default: () => {} },
});

const isFocused = ref(false);

const onSearch = () => {
  props.onSearch?.(model.value);
};

const onClear = () => {
  model.value = "";
  props.onSearch?.("");
};
</script>

<style scoped>
.lms_search_input {
  display: flex;
  align-items: center;
  gap: 16px;
  height: 48px;
  width: 300px;
  padding: 8px 8px 8px 12px;
  border: 1px solid var(--lms-outline-gray-main, #e0e0e0);
  border-radius: 4px;
  background-color: var(--lms-surface, #ffffff);
  transition: border-color 0.2s;
  box-sizing: border-box;
}

.lms_search_input:hover {
  border-color: var(--lms-outline-black, #aaabab);
}

.lms_search_input.focused {
  border-color: var(--lms-primary-400, #5c74f6);
  border-width: 2px;
  padding: 7px 7px 7px 11px;
}

.lms_search_icon {
  flex-shrink: 0;
  font-size: 24px;
  color: var(--lms-on-surface-low, rgba(0, 0, 0, 0.35));
}

.lms_search_field {
  flex: 1;
  border: none;
  outline: none;
  background: transparent;
  font-family: "Pretendard", sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.5;
  color: var(--lms-on-surface-high, rgba(0, 0, 0, 0.8));
  min-width: 0;
}

.lms_search_field::placeholder {
  color: var(--lms-on-surface-low, rgba(0, 0, 0, 0.35));
}

.lms_search_field::-webkit-search-cancel-button {
  display: none;
}

.lms_search_clear {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  padding: 0;
  border: none;
  background: transparent;
  color: var(--lms-on-surface-low, rgba(0, 0, 0, 0.35));
  cursor: pointer;
}

.lms_search_clear:hover {
  color: var(--lms-on-surface-medium, rgba(0, 0, 0, 0.6));
}

.lms_search_clear .mdi {
  font-size: 20px;
}
</style>
